import { BoxId } from "../types/box_id";
import { Turn } from "../types/turn";

interface State {
  /** ターン */
  turn: Turn;
  /** 手の位置 */
  handPositionBoxId: BoxId | null;
  /** 横取り表示の位置 */
  stealPositionBoxId: BoxId | null;
  /** 手が持っているボールの個数 */
  handBallCount: number;
  /** ボックス毎のボールの個数 */
  boxBallCount: Record<BoxId, number>;
}

export const initialState: State = {
  turn: "A",
  handPositionBoxId: null,
  stealPositionBoxId: null,
  handBallCount: 0,
  boxBallCount: {
    // Aさん
    0: 4,
    1: 4,
    2: 4,
    3: 4,
    4: 4,
    5: 4,
    6: 0,
    // Bさん
    7: 4,
    8: 4,
    9: 4,
    10: 4,
    11: 4,
    12: 4,
    13: 0,
  },
};
